export function getStagingLivingLabel(configurationOptions) {
  const labels = []
  const { include_in_sparx_living, include_in_sparx_staging } = configurationOptions
  if (include_in_sparx_living) {
    labels.push(' · L')
  }
  if (include_in_sparx_staging) {
    labels.push(' · S')
  }
  return labels.join('')
}
